module.exports = __webpack_public_path__ + "img/FlashStation FS6400.eeb7a74e.png";